import * as actionTypes from './actionTypes';
import * as api from '../api';
import { user as userSchema, arrayOfUsers as arrayOfUsersSchema, normalize } from '../../helpers/schema';

import { createActionObject, getNoArgDispatcherFunc, getAjaxFunc } from '../../helpers/common';
import { userStatus } from '../constants';
import * as strings from '../../helpers/strings';
import { snackBarVisiblePeriod } from '../../helpers/constants';

export const addNewUser = getNoArgDispatcherFunc(actionTypes.ADD_NEW_USER);

export const create = user => dispatch => getAjaxFunc(
  actionTypes.CREATE_USER_REQUEST,
  "",
  actionTypes.CREATE_USER_FAILURE,
  strings.msgSaveFailed,
  dispatch
)(
  () => api.create(user)
    .then(({ status, data, message }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.CREATE_USER_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        case 403:
          dispatch(
            createActionObject(
              actionTypes.CREATE_USER_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.CREATE_USER_SUCCESS,
              {
                ...normalize(data, userSchema),
                message: strings.msgSavedSuccessfully,
                user: data
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const update = user => dispatch => getAjaxFunc(
  actionTypes.UPDATE_USER_REQUEST,
  "",
  actionTypes.UPDATE_USER_FAILURE,
  strings.msgSaveFailed,
  dispatch
)(
  () => api.update(user)
    .then(({ status, data, message }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_USER_FAILURE,
              {
                message: strings.msgSaveFailed
              }
            )
          );
          break;
        case 403:
          console.log(message)
          dispatch(
            createActionObject(
              actionTypes.UPDATE_USER_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_USER_SUCCESS,
              {
                ...normalize(data, userSchema),
                message: strings.msgSavedSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const deactivate = userId => dispatch => getAjaxFunc(
  actionTypes.DEACTIVATE_USER_REQUEST,
  "",
  actionTypes.DEACTIVATE_USER_FAILURE,
  strings.msgDeactivationFailed,
  dispatch
)(
  () => api.deactivate(userId)
    .then(({ status, message, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.DEACTIVATE_USER_FAILURE,
              {
                message: strings.msgDeactivationFailed
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.DEACTIVATE_USER_SUCCESS,
              {
                userId,
                status: userStatus.inActive,
                message: strings.msgDeactivatedSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const activate = userId => dispatch => getAjaxFunc(
  actionTypes.ACTIVATE_USER_REQUEST,
  "",
  actionTypes.ACTIVATE_USER_FAILURE,
  strings.msgActivationFailed,
  dispatch
)(
  () => api.activate(userId)
    .then(({ status, message, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.ACTIVATE_USER_FAILURE,
              {
                message: strings.msgActivationFailed
              }
            )
          );
          break;
        case 403:
          dispatch(
            createActionObject(
              actionTypes.ACTIVATE_USER_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.ACTIVATE_USER_SUCCESS,
              {
                userId,
                status: userStatus.active,
                message: strings.msgActivatedSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const search = criteria => dispatch => getAjaxFunc(
  actionTypes.SEARCH_USERS_REQUEST,
  "",
  actionTypes.SEARCH_USERS_FAILURE,
  "",
  dispatch
)(
  () => api.search(criteria)
    .then(({ status, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_USERS_FAILURE
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_USERS_SUCCESS,
              {
                ...normalize(data.list, arrayOfUsersSchema),
                totalRecord: data.totalRecord,
                totalPage: data.totalPage,
                startIndex: criteria.startIndex
              }
            )
          );
      }
    })
)()

export const clientSearch = criteria => dispatch => getAjaxFunc(
  actionTypes.SEARCH_USERS_REQUEST,
  "",
  actionTypes.SEARCH_USERS_FAILURE,
  "",
  dispatch
)(
  () => api.clientSearch(criteria)
    .then(({ status, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_USERS_FAILURE
            )
          );
          break;
        default:
          console.log(data)
          dispatch(
            createActionObject(
              actionTypes.SEARCH_USERS_SUCCESS,
              {
                ...normalize(data.list, arrayOfUsersSchema),
                totalRecord: data.totalRecord,
                totalPage: data.totalPage,
                startIndex: criteria.startIndex
              }
            )
          );
      }
    })
)()

export const subClientSearch = companyName => dispatch => getAjaxFunc(
  actionTypes.SEARCH_SUB_CLIENT_USERS_REQUEST,
  "",
  actionTypes.SEARCH_SUB_CLIENT_USERS_FAILURE,
  "",
  dispatch
)(
  () => api.subClientSearch(companyName)
    .then(({ status, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_SUB_CLIENT_USERS_FAILURE
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_SUB_CLIENT_USERS_SUCCESS,
              {
                data: data
              }
            )
          );
      }
    })
)()

export const selectUser = user => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_USER,
    { user }
  )
)

export const currentUser = criteria => dispatch => getAjaxFunc(
  actionTypes.CURRENT_USER_REQUEST,
  "",
  actionTypes.CURRENT_USER_FAILURE,
  "",
  dispatch
)(
  () => api.search(criteria)
    .then(({ status, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.CURRENT_USER_FAILURE
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.CURRENT_USER_SUCCESS,
              {
                ...normalize(data.list, arrayOfUsersSchema),
                totalRecord: data.totalRecord,
                startIndex: criteria.startIndex
              }
            )
          );
      }
    })
)()